///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";

import { analyticsView } from "../../../helpers/types";
import CarrierViewGrid from "./CarrierViewGrid";
import LaneViewGrid from "./LaneViewGrid";
import LoadViewGrid from "./LoadViewGrid";
import RadialBar from "./RadialBar";
import SelectViewSection from "./SelectViewSection";
import ShipperViewGrid from "./ShipperViewGrid";
import ShipperRatesViewGrid from "./ShipperRatesViewGrid";

export const AnalyticsGridSection = ({ division }) => {
  const {
    analytics: {
      selectedAnalyticsGridView,
      loadView: { lanes: loadViewLanes },
      carrierView: { lanes: carrierViewLanes },
      loads
    }
  } = useSelector(state => state);

  return (
    <>
      {loads?.length > 0 && (
        <div
          data-testid="analytics-grid-section"
          className="analytics-grid-section"
        >
          <RadialBar />
          <div className="one-whole pb-32 flex flex-wrap" id="analytics-grid">
            {selectedAnalyticsGridView === analyticsView.shipperRatesView ? (
              <ShipperRatesViewGrid division={division} />
            ) : (
              <>
                <div className="grid__cell left-grid-section border-right-silver">
                  {selectedAnalyticsGridView === analyticsView.laneView && (
                    <LaneViewGrid division={division} />
                  )}
                  {selectedAnalyticsGridView === analyticsView.shipperView && (
                    <ShipperViewGrid division={division} />
                  )}
                </div>
                <div className="grid__cell right-grid-section">
                  {!loadViewLanes && !carrierViewLanes && <SelectViewSection />}
                  {loadViewLanes && <LoadViewGrid division={division} />}
                  {carrierViewLanes && <CarrierViewGrid division={division} />}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AnalyticsGridSection;
